import React from 'react';
import styled from 'styled-components';
import { Loader } from '../components';

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 160px;
`;

export default () => (
  <Wrapper>
    <Loader />
  </Wrapper>
);
